import { atomWithKey as atom } from "./atomWithKey";

export const termsofUseContentResponseAtom = atom<any>({
  key: "termsofUseContentResponseAtom",
  default: "",
});
